import { assignCohort, setNewRelicCustomAttribute, type CohortVariant } from '@verifime/utils';

const EXPERIMENT_KEY = 'next16-client-portal';
const CANDIDATE_PERCENT = 50;
const COOKIE_NAME = 'vfm_cohort';

/**
 * Assign this client user a sticky 50/50 cohort from their Cognito sub, tag New
 * Relic (cohort + build) so JS errors can be faceted by variant, and set the
 * routing cookie the edge router will consume later. Routing is not live yet, so
 * the cookie is currently inert and no reload is performed here.
 */
export function assignAndTagCohort(userKey: string): CohortVariant {
  const variant = assignCohort(userKey, EXPERIMENT_KEY, CANDIDATE_PERCENT);
  const build = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? 'local';
  setNewRelicCustomAttribute('cohort', variant);
  setNewRelicCustomAttribute('build', build);
  try {
    // The routing cookie is inert/best-effort, just like the New Relic tags above: it
    // is not consumed until the later edge-router phase. A write failure (e.g. a
    // sandboxed or opaque-origin document, where the cookie setter throws a
    // SecurityError) must not crash the authenticated shell, which runs this
    // unconditionally from a useEffect in AuthenticatedContainer.
    document.cookie = `${COOKIE_NAME}=${variant}; path=/; SameSite=Lax`;
  } catch {
    // Swallow: cookie write failure is non-fatal, see comment above.
  }
  return variant;
}
